import { AuthRouteImport } from './Import'
import PageNotFound from './PageNotFound'
const { RoutesMap, UserLogin, VendorProfile, Home, PrivacyPolicy, TermsConditions, ReturnRefundPolicy } = AuthRouteImport

const AuthRoute = () => {
    return [
        {
            path: RoutesMap.HOME.path,
            element: <Home />
        },
        {
            path: RoutesMap.HOMESECOND.path,
            element: <Home />
        },
        {
            path: RoutesMap.LOGIN.path,
            element: <UserLogin />
        },
        {
            path: RoutesMap.PROFILE_PAGE.path,
            element: <VendorProfile />
        },
        {
            path: RoutesMap.UNKNOWN_PATH.path,
            element: <PageNotFound />
        },
        {
            path: RoutesMap.PRIVACY_POLICY.path,
            element: <PrivacyPolicy />
        },
        {
            path: RoutesMap.TERMS_CONDITIONS.path,
            element: <TermsConditions />
        },
        {
            path: RoutesMap.RETURN_REFUND_POLICY.path,
            element: <ReturnRefundPolicy />
        },
    ]
}

export default AuthRoute;